import './tailwind.css'

if (import.meta.env.DEV) {
  if (window.location.hostname === 'localhost')
    window.location.hostname = 'app.resolved.localhost'
}

async function bootstrap() {
  void import('lib/src/composables/core/plugin-dayjs.ts').then(({ initDayjs }) => initDayjs())

  if (import.meta.env.VITE_MOCKED === 'true' || import.meta.env.VITE_TESTING === 'test') {
    const { ensureBrowserMswStarted } = await import('mocks')
    await ensureBrowserMswStarted()
  }

  await import('./main-app')
}

bootstrap().catch(async (error) => {
  console.error('[main] bootstrap failed:', error)
  const { setBootstrapError } = await import('lib/src/composables/utils/useAppErrorState.ts')
  setBootstrapError(error)
  await import('./main-app')
})
